/// <reference types="vite-plugin-svgr/client" />
import { lazy, StrictMode, Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import 'reflect-metadata';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './common/clients';
import { iosPWASplash } from '@monocle-money/ios-pwa-splash';
import { Splash } from './Splash';

const themeColor = document
 .querySelector('meta[name="theme-color"]')
 ?.getAttribute('content') ?? '#00000';
iosPWASplash('/icon-512x512.png', themeColor);

const root = ReactDOM.createRoot(
  document.body
);

const App = lazy(() => import('./App'));

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Splash />}>
        <App/>
      </Suspense>
    </QueryClientProvider>
  </StrictMode>
);